import CrewLayout from "@/components/layouts/CrewLayout";
import useAuth from "@/hooks/useAuth";
import { hasAdminPortal } from "@/lib/permissions";
import { Redirect } from "expo-router";

export default function Layout() {
  const { userRoles } = useAuth();
  if (hasAdminPortal(userRoles)) return <Redirect href="/(app)/(root)" />;
  return <CrewLayout />;
}
